var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"py-2 text-white bg-dark"},[_c('div',{staticClass:"container text-center"},[_c('p',[_vm._v("Copyright © "+_vm._s(_vm.company)+" 2018-"+_vm._s(_vm.getCurrentYear())+". "+_vm._s(_vm.$t('copyright'))+".")])])])}
var staticRenderFns = []

export { render, staticRenderFns }